/* nav
========================================================= */
export function nav($) {
  $(window).on('load', function () {
    const $header = $('#header');
    const $body = $('body');
    const $drawerMenuButton = $('#js__drawerMenuBtn');
    const mediaQuery = window.matchMedia('(max-width: 1024px)');

    $header.addClass('active');

    if (!$drawerMenuButton.length) {
      return;
    }

    function handleMediaQuery(mq) {
      $drawerMenuButton.off('click.nav');

      if (!mq.matches) {
        $body.removeClass('open');
        return;
      }

      $drawerMenuButton.on('click.nav', function () {
        const isOpen = $body.toggleClass('open').hasClass('open');

        if (!isOpen || typeof anime === 'undefined') {
          return;
        }

        const timeline = anime.timeline({
          loop: false,
        });

        timeline
          .add({
            targets: '.gnav__list--sp li',
            opacity: [0, 1],
            translateY: [20, 0],
            delay: anime.stagger(100),
            duration: 2000,
          })
          .add(
            {
              targets: '.gnav__btn-tel',
              opacity: [0, 1],
              translateY: [20, 0],
              duration: 2000,
            },
            700
          );
      });
    }

    handleMediaQuery(mediaQuery);

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleMediaQuery);
    } else {
      mediaQuery.addListener(handleMediaQuery);
    }

    $('ul.gnav__list--sp li a.in-page').on('click.nav', function () {
      $body.removeClass('open');
    });
  });
}
